import { Component, ContentChildren, Input, QueryList, TemplateRef } from "@angular/core";

import { InputBoolean } from "ng-zorro-antd/core/util";

import { NzInputGroupComponent } from "ng-zorro-antd/input";
import { UiInputDirective } from "@webapp/ui/input/input.directive";
import { UiSizeLDSType } from "@webapp/ui/core/models/ui-size.models";

@Component({
  selector: "ui-input-group",
  exportAs: "uiInputGroup",
  templateUrl: "input-group.component.html",
})
export class UiInputGroupComponent extends NzInputGroupComponent {
  @ContentChildren(UiInputDirective) public listOfNzInputDirective!: QueryList<UiInputDirective>;
  @Input("uiAddOnBeforeIcon") public nzAddOnBeforeIcon?: string | null = null;
  @Input("uiAddOnAfterIcon") public nzAddOnAfterIcon?: string | null = null;
  @Input("uiPrefixIcon") public nzPrefixIcon?: string | null = null;
  @Input("uiSuffixIcon") public nzSuffixIcon?: string | null = null;
  @Input("uiAddOnBefore") public nzAddOnBefore?: string | TemplateRef<void>;
  @Input("uiAddOnAfter") public nzAddOnAfter?: string | TemplateRef<void>;
  @Input("uiPrefix") public nzPrefix?: string | TemplateRef<void>;
  @Input("uiSuffix") public nzSuffix?: string | TemplateRef<void>;
  @Input("uiSize") public nzSize: UiSizeLDSType = "default";
  @Input("uiSearch") @InputBoolean() public nzSearch = false;
  @Input("uiCompact") @InputBoolean() public nzCompact = false;
}
